module.exports = __webpack_public_path__ + "img/expenses.caf72557.png";